<template>
  <div
    class="modal fade"
    id="add-notification"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-notification-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("notifications.new_notification") }}</h4>
          </div>
          <div class="row g-6">
            <div class="col-sm-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("notifications.type.type")
              }}</label>
              <select
                class="form-select w-100"
                @change="changeType"
                v-model="notification.type"
                data-style="btn-default"
              >
                <option
                  v-for="ft in [
                    { id: 'account', name: $t('notifications.type.account') },
                    { id: 'profile', name: $t('notifications.type.profile') },
                    { id: 'nas', name: $t('notifications.type.nas') },
                    { id: 'ssr', name: $t('notifications.type.ssr') },
                  ]"
                  v-bind:key="ft.id"
                  :value="ft.id"
                  >{{ ft.name }}</option
                >
              </select>
            </div>
            <div v-if="notification.type == 'account'" class="col-sm-6">
              <label class="form-label" for="selectpickerBasic33">{{
                $t("notifications.type.account")
              }}</label>
              <!-- <Multiselect
                class="p-1 h-9 rounded-full shadow-lg"
                @select="validate"
                v-model="this.notification.account_id"
                :trackBy="'value'"
                :label="'label'"
                :searchable="true"
                :placeholder="$t('control.filter')"
                :options="accounts"
                :internal-search="false"
                open-direction="top"
                @search-change="fetchAccounts"
                :loading="int_loading"
              /> -->
            </div>
            <div v-if="notification.type == 'profile'" class="col-sm-6">
              <label class="form-label" for="selectpickerBasic33">{{
                $t("notifications.type.profile")
              }}</label>
              <Multiselect
                class="p-1 h-9 rounded-full shadow-lg"
                @select="validate"
                v-model="this.notification.profile_id"
                :trackBy="'value'"
                :label="'label'"
                :searchable="true"
                :placeholder="$t('control.filter')"
                :options="profiles"
                :internal-search="false"
                open-direction="top"
                @search-change="fetchProfiles"
                :loading="int_loading"
              />
            </div>
            <div v-if="notification.type == 'nas'" class="col-sm-6">
              <label class="form-label" for="selectpickerBasic33">{{
                $t("notifications.type.nas")
              }}</label>
              <Multiselect
                class="p-1 h-9 rounded-full shadow-lg"
                @select="validate"
                v-model="this.notification.nas_id"
                :trackBy="'value'"
                :label="'label'"
                :searchable="true"
                :placeholder="$t('control.filter')"
                :options="nases"
                :internal-search="false"
                open-direction="top"
                @search-change="fetchNases"
                :loading="int_loading"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("notifications.title")
              }}</label>
              <input
                type="text"
                v-model="notification.title"
                @input="validate"
                :class="{ 'is-invalid': errors.title }"
                class="form-control"
                id="basic-url3"
                aria-describedby="basic-addon34"
                placeholder="Title"
              />
            </div>
            <div class="col-12">
              <div class="input-group input-group-merge">
                <span class="input-group-text">Notification<br />Text</span>
                <textarea
                  class="form-control"
                  @input="validate"
                  v-model="notification.body"
                  :class="{ 'is-invalid': errors.body }"
                  aria-label="SSR Comment"
                ></textarea>
              </div>
            </div>
            <div v-if="!validated" class="col-12 text-danger">
              * {{ $t("notifications.error") }}
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                v-if="!confirmation"
                @click.prevent="confirmation = true"
                :disabled="!validated"
              >
                {{ $t("notifications.push") }}
              </button>
            </div>
            <div v-if="confirmation" class="col-12 d-flex justify-between">
              <div>
                {{ $t("notifications.confirm") }}
              </div>
              <button
                class="btn btn-danger"
                @click.prevent="confirmation = false"
              >
                {{ $t("control.no") }}
              </button>
              <button
                class="btn btn-success"
                @click.prevent="store"
                :disabled="loading"
              >
                {{ $t("control.yes") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment, { months } from "moment";
import { hasPrivilege } from "../../global_constants.js";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "notificationsAdd",
  name: "PushNotification",
  props: ["visible"],
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      profiles: [],
      accounts: [],
      nases: [],
      confirmation: false,
      loading: false,
      notification: {
        title: "",
        body: "",
        type: "account",
        account_id: null,
        profile_id: null,
        nas_id: null,
      },
      errors: {
        title: null,
        body: null,
        id: null,
      },
      validated: false,
      text_direction:
        this.$i18n.locale == "ar" ? "direction:rtl" : "direction:ltr",
      int_loading: false,
      debounce: null,
    };
  },
  async created() {
    await this.fetchProfiles();
    this.loading = false;
  },
  methods: {
    hide() {
      this.$emit("hide-details");
    },
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async store() {
      this.loading = true;
      const response = await axios.post(`/notifications`, this.notification);
      if (response.status == 200) {
        document.getElementById("add-notification-close").click();
        this.$notify({
          text: this.$t("messages.notification_pushed_successfully"),
          type: "success",
        });
        this.loading = false;
        this.$emit("updated");
      }
    },
    async fetchProfiles(query) {
      this.int_loading = true;
      const response = await axios.get(`/profiles?name=${query}`);
      if (response.status == 200) {
        if (!this.notification.profile_id) this.profiles = [];
        const profiles = response.data.data;
        profiles.forEach((element) => {
          this.profiles.push({ value: element.id, label: element.name });
        });
      }
      this.int_loading = false;
    },
    async fetchAccounts(query) {
      this.int_loading = true;
      const response = await axios.get(`/accounts?username=${query}`);
      if (response.status == 200) {
        if (!this.notification.account_id) this.accounts = [];
        const accounts = response.data.data;
        accounts.forEach((element) => {
          this.accounts.push({ value: element.id, label: element.username });
        });
      }
      this.int_loading = false;
    },
    async fetchNases(query) {
      this.int_loading = true;
      const response = await axios.get(`/nases?itr=true&shortname=${query}`);
      if (response.status == 200) {
        if (!this.notification.nas_id) this.nases = [];
        const nases = response.data.data;
        nases.forEach((element) => {
          this.nases.push({ value: element.id, label: element.shortname });
        });
      }
      this.int_loading = false;
    },
    changeType() {},
    validate() {
      this.validated = true;
      this.errors.title = null;
      this.errors.body = null;
      this.errors.id = null;
      if (this.notification.title == "") {
        this.errors.title = true;
        this.validated = false;
      }
      if (this.notification.body == "") {
        this.errors.body = true;
        this.validated = false;
      }
      if (
        this.notification.type == "account" &&
        this.notification.account_id == null
      ) {
        this.errors.id = true;
        this.validated = false;
      }
      if (
        this.notification.type == "profile" &&
        this.notification.profile_id == null
      ) {
        this.errors.id = true;
        this.validated = false;
      }
      if (this.notification.type == "nas" && this.notification.nas_id == null) {
        this.errors.id = true;
        this.validated = false;
      }
    },
  },
};
</script>
